<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div
        class="flex-no-shrink w-12 h-12 rounded-lg text-white p-1"
        :class="this.module.settings.icon_color ? this.module.settings.icon_color : 'bg-tertiary'"
      >
        <!-- <i
          class="fas fa-2x"
          :class="`fa-${this.module.settings.icon}`"
        /> -->
        <icon :name="this.module.settings.icon" />
      </div>
      <h3 class="text-2xl font-medium ml-4">
        {{ module.title }}
      </h3>
    </div>
    <p class="text-base leading-tight mb-6" v-html="nl2br(module.settings.description)"></p>
    <button
      v-if="module.permissions && module.permissions.operator === 'contains' && module.permissions.permission === 'activate automated referrals' && selectedOffice.automated_referrals_permission === true"
      class="mb-2 p-3 inline-block no-underline bg-green button-text-color text-center text-sm w-full rounded uppercase pointer-events-none"
    >
      <i class="fas fa-check"></i> Active
    </button>
    <a
      v-else
      :href="module.settings.link"
      :target="this.target"
      class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase"
    >
      {{ module.settings.action }}
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { nl2br } from '@/helpers'

export default {
  props: ['module', 'page'],

  data () {
    return {
      target: '_blank'
    }
  },
  computed: {
    ...mapState([
      'system',
      'selectedOffice'
    ]),
    internalLink () {
      return this.module.settings.link.includes(this.system.domain)
    }
  },
  created () {
    this.getLinkTarget()
  },
  methods: {
    nl2br,
    getLinkTarget () {
      if (this.internalLink) {
        this.target = '_self'
      }
    }
  }
}
</script>
